var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddSmall16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12a1 1 0 102 0V9h3a1 1 0 100-2h-3V4a1 1 0 00-2 0v3h-3a1 1 0 000 2h3v3z",
    fill: "#2C2D2E"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNSAxMkM3LjUgMTIuNTUyMyA3Ljk0NzcyIDEzIDguNSAxM0M5LjA1MjI5IDEzIDkuNSAxMi41NTIzIDkuNSAxMlY5SDEyLjVDMTMuMDUyMyA5IDEzLjUgOC41NTIyOCAxMy41IDhDMTMuNSA3LjQ0NzcyIDEzLjA1MjMgNyAxMi41IDdIOS41VjRDOS41IDMuNDQ3NzIgOS4wNTIyOCAzIDguNSAzQzcuOTQ3NzEgMyA3LjUgMy40NDc3MiA3LjUgNEw3LjUgN0g0LjVDMy45NDc3MiA3IDMuNSA3LjQ0NzcyIDMuNSA4QzMuNSA4LjU1MjI4IDMuOTQ3NzIgOSA0LjUgOUg3LjVMNy41IDEyWiIgZmlsbD0iIzJDMkQyRSIvPgo8L3N2Zz4K";
export { SvgAddSmall16 as ReactComponent };